import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const FeaturedResearch = () => {
  const researchItems = [{
    id: 1,
    title: 'Microbiome Diversity in Urban vs. Rural Settings',
    description: 'Our landmark study examining how environment affects gut microbiome composition across diverse populations.',
    image: 'https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#research-1'
  }, {
    id: 2,
    title: 'Probiotic Efficacy Analysis',
    description: 'Rigorous testing of 50+ commercial probiotics to determine actual microbial viability and colonization potential.',
    image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#research-2'
  }, {
    id: 3,
    title: 'Diet-Microbiome Interactions',
    description: 'Investigating how specific dietary patterns influence microbiome composition and metabolite production.',
    image: 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#research-3'
  }, {
    id: 4,
    title: 'Microbiome Testing Methods Comparison',
    description: 'Critical evaluation of current commercial and clinical microbiome testing methodologies.',
    image: 'https://images.unsplash.com/photo-1579154341098-e4e158cc7f55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    link: '#research-4'
  }];
  return <section id="research" className="py-16 bg-gray-50" data-id="element-798" data-mp="2bx9jigqdg8bf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-799" data-mp="2byt0yanrkpes">
        <div className="text-center mb-12" data-id="element-800" data-mp="19kd2qp168e6d">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-801" data-mp="19hh2uv5rjffa">
            Featured Research
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-802" data-mp="1ik9wv66by58t">
            Exploring the frontiers of microbiome science with rigorous,
            independent research
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-803" data-mp="1sa1r1zaiowcr">
          {researchItems.map((item, index) => <div key={item.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-804" data-mp="1x8d1ab4q58vi" data-mpi={index}>
              <div className="h-48 overflow-hidden" data-id="element-805" data-mp="269kmpsm56f86">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" data-id="element-806" data-mp="2691h9bdohjb1" />
              </div>
              <div className="p-6" data-id="element-807" data-mp="4cagfk1nc3lo">
                <h3 className="font-bold text-lg mb-2 text-gray-900" data-id="element-808" data-mp="4dc2ejk7aai6">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-4 text-sm" data-id="element-809" data-mp="3vpesb8ehnocw">{item.description}</p>
                <Link to={item.link} className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium text-sm" data-id="element-810" data-mp="3qswqohegg64s">
                  Read the study <ArrowRightIcon size={16} className="ml-1" data-id="element-811" data-mp="na3gmekvxzfd" />
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};